import {proposalrequest, users} from '@mep/pae-commons';
import React from 'react';

import {MunicipalityEnumByUserLevel} from '@/components/MunicipalityEnumByUserLevel';
import {ValueMunicipalityEnumComponent} from '@/components/MunicipalityEnumComponent';
import {ProvinceEnumFilterComponent, ProvinceValueEnumFilterComponent} from '@/components/ProvinceEnumFilterComponent';
import {ValueRemoteData} from '@/components/TableFilters/components/Types/RemoteDataComponent';
import {ProposalFilterOwner} from '@/modules/proposalRequest/components/ProposalFilterOwner';
import {_filters} from '@/modules/proposalRequest/components/ProposalUserAssigned';
import {authentication} from '@/settings';

const {USER_ACCESS_LEVELS} = users;

const {PROPOSAL_STATUS_ENUM, SUBJECT_TYPE_ENUM} = proposalrequest;

export const filters = [
  {
    name: 'proposalRequest.filters.certificationAval',
    field: 'certificationAval',
    type: 'exist',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.commercialization',
    field: 'commercialization',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.columns.owner',
    field: ['owner', 'owner.id'],
    // eslint-disable-next-line react/prop-types,react/display-name
    render: ({...props}) => <ProposalFilterOwner {...props}/>,
    // eslint-disable-next-line react/prop-types,react/display-name
    renderValue: ({...rest}) => <ValueRemoteData {...rest}/>,
  },
  {
    name: 'proposalRequest.columns.type',
    type: 'enum',
    field: 'subjectType',
    options: SUBJECT_TYPE_ENUM.map(e => {
      const label = `types.${e}`;
      return ({label, value: e});
    })
  },
  {
    name: 'provinces',
    field: 'address.province',
    enableFnc: (user) => user?.level === USER_ACCESS_LEVELS?.NATIONAL,
    // eslint-disable-next-line react/display-name
    render: (props) => <ProvinceEnumFilterComponent {...props}/>,
    // eslint-disable-next-line react/display-name
    renderValue: (props) => <ProvinceValueEnumFilterComponent {...props}/>
  },
  {
    name: 'municipalities',
    search: true,
    type: 'enum',
    field: 'address.municipality',
    enableFnc: (user) => [USER_ACCESS_LEVELS?.PROVINCE, USER_ACCESS_LEVELS?.NATIONAL].includes(user?.level),
    // eslint-disable-next-line react/display-name
    renderValue: (props) => <ValueMunicipalityEnumComponent {...props}/>,
    // eslint-disable-next-line react/display-name
    render: (props) => <MunicipalityEnumByUserLevel {...props}/>
  },
  {
    name: 'proposalRequest.columns.workers',
    field: 'miPymeExpectedWorkers',
    type: 'number',
    min: 1,
    max: 100
  },
  {
    name: 'status',
    type: 'enum',
    field: 'status',
    options: PROPOSAL_STATUS_ENUM.sort().map(e => {
      const label = `proposalRequest.status.${e}`;
      return ({label, value: e});
    })
  },
  {
    name: 'proposalRequest.columns.assigned',
    type: 'dynamic',
    request: `${authentication.path}/api/users/search`,
    filters: _filters.toQuery(),
    field: 'assigned',
    labelKey: 'fullName',
    supportEmpty: true,
    emptyLabel: 'unassigned',
  },
  {
    name: 'proposalRequest.filters.hasExported',
    field: 'hasExported.active',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.onProtectedArea',
    field: 'onProtectedArea.active',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.incubating',
    field: 'incubating.active',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.localDevelopment',
    field: 'localDevelopment.active',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.isReconversion',
    field: ['isReconversion', 'reconversion'],
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.mainActivity',
    type: 'dynamic',
    request: `${authentication.path}/api/cnae-activities/search`,
    field: ['mainActivity', 'mainActivity.id'],
    labelKey: 'name',
  },
  {
    name: 'proposalRequest.filters.activities',
    type: 'dynamic',
    request: `${authentication.path}/api/cnae-activities/search`,
    field: ['activities', 'activities.id'],
    labelKey: 'name',
  },
  {
    name: 'createdAt',
    field: 'createdAt',
    type: 'dateRange',
  },
  {
    name: 'proposalRequest.filters.timePass',
    field: 'metadata.sentAt',
    type: 'dateRange',
  },
  {
    name: 'proposalRequest.filters.timePassFromValidated',
    field: 'metadata.validatedAt',
    type: 'dateRange',
  },
  {
    name: 'proposalRequest.filters.acceptedAt',
    field: 'metadata.acceptedAt',
    type: 'dateRange',
  },
  {
    name: 'proposalRequest.filters.notaryEdited',
    field: 'notaryEdited',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
  {
    name: 'proposalRequest.filters.organization',
    type: 'dynamic',
    request: `${authentication.path}/api/organizations/search`,
    field: ['organization', 'organization.id'],
    labelKey: 'name',
  },
  {
    name: 'proposalRequest.filters.previousCNAData',
    field: 'previousCNAData.active',
    type: 'bool',
    trueText: 'filter.trueText',
    falseText: 'filter.falseText',
  },
];
